import { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { api } from "../lib/api";
import { auth } from "../lib/firebase";

/**
 * First sign-in of a hall owner: name the organization, become its owner.
 * The API seeds the chart of accounts and mints the owner claim; a token
 * refresh then unlocks the panel.
 */
export function OnboardingPage() {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function createOrg() {
    setBusy(true);
    setError(null);
    try {
      await api("/orgs", { method: "POST", body: { name: name.trim() } });
      await auth.currentUser?.getIdToken(true);
      window.location.assign("/");
    } catch (e) {
      setError(e instanceof Error ? e.message : "خطا در ساخت سازمان");
      setBusy(false);
    }
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="background.default"
    >
      <Card sx={{ width: 440, mx: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" color="primary" mb={0.5}>
            خوش آمدید 👋
          </Typography>
          <Typography color="text.secondary" mb={3}>
            برای شروع، نام تجارت یا تالارتان را ثبت کنید. بعد از این قدم، پنل
            کامل (رزروها، مالی، گدام، کارمندان…) برای شما باز می‌شود.
          </Typography>
          <Stack spacing={2}>
            <TextField
              label="نام سازمان / تالار"
              placeholder="مثلاً: شرکت تالارهای آریانا"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              fullWidth
            />
            {error && <Alert severity="error">{error}</Alert>}
            <Button
              variant="contained"
              size="large"
              onClick={createOrg}
              disabled={busy || name.trim().length < 2}
            >
              {busy ? "در حال ساخت…" : "ساخت سازمان و ورود به پنل"}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
